import { z, ZodType } from 'zod';
import { AccountTreeValue, accountTreeValueSchema } from './account-tree-value';

export type AccountTreeNode = {
	id: number;
	value: AccountTreeValue;
	children: AccountTreeNode[];
};

export const accountTreeNodeSchema: ZodType<AccountTreeNode> = z.object({
	id: z.number(),
	value: accountTreeValueSchema,
	children: z.array(z.lazy(() => accountTreeNodeSchema)),
});
